var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabScheduler({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1765866196420,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 7758,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1004.4 420.8H644.1l241.8 423C968.1 751.7 1013 635 1013 510.5c0-29.2-2.9-59.3-8.6-89.7z m-17.5-68.7C938.4 206.2 825 89.6 679.9 37.6L499.6 349.9l487.3 2.2zM611.6 18.4C578.3 11.4 544.5 8 510.5 8 390.9 8 276.7 50.2 185.8 127.7l180.1 312L611.6 18.4zM135.1 177.3C52.7 269.3 8 386 8 510.5c0 29.2 2.8 59.3 8.5 89.7l360.4 0.1-241.8-423zM34 669.1c48.4 145.8 161.9 262.3 307 314.3L521.3 671 34 669.1z m375.3 333.5c33.4 6.9 67.3 10.3 101.2 10.3 119.6 0 233.7-42.3 324.7-119.5L655 581.4l-245.7 421.2z m0 0",
    "p-id": 7759,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabScheduler);
export default __webpack_public_path__ + "static/media/tab-scheduler.b7a524d4643da5f408c0484cb00f442f.svg";
export { ForwardRef as ReactComponent };